export const messages = {
  cancelButtonLabel: {
    id: 'authoring.texteditor.baseModal.cancelButtonLabel',
    defaultMessage: 'Cancel',
    description: 'Label for cancel button.',
  },
};

export default messages;
